ACC.newOrderHistory = {
  spDeliveryInformation: function(data) {
    var $spItem = $('.showAllSPSOrder'),
        $spsReason = $('.spsOrderReasonType'),
        orderReasonText = $spItem.attr('data-orderReason'),
        fcoNumberText = $spItem.attr('data-fcoNumber'),
        incidentNumberText = $spItem.attr('data-incidentNumber'),
        workOrderNumberText = $spItem.attr('data-workOrderNumber'),
        pStrong = '<p class="strong">',
        divColSix = '<div class="ph-col-6 ph-float-left">\n',
        divColTwelve = ' <div class="ph-col-12 ph-p-0 ph-float-left">\n',
        structure = '';

    if (data.orderReasonType !== '' && data.orderReasonType !== null) {
      structure = structure + divColTwelve +
        divColSix +
        pStrong + orderReasonText + '</p>\n' +
        '</div>\n' +
        divColSix +
        '<p>' + $spsReason.attr('data-' + data.orderReasonType) + '</p>\n' +
        '</div>\n' +
        '</div>';
    }

    if (data.fcoNumber && data.fcoNumber.code && $('.ph-ishhs').text() === 'true') {
      structure = structure + divColTwelve +
        divColSix +
        pStrong + fcoNumberText + '</p>\n' +
        '</div>\n' +
        '<div class="ph-col-6 ph-float-left">\n' +
        '<p class="ph-hhs-paymentmethod">' + data.fcoNumber.code + '</p>\n' +
        '</div>\n' +
        '</div>';
    }

    if (data.incidentNumber !== '' && data.incidentNumber !== null) {
      structure = structure + divColTwelve +
        divColSix +
        pStrong + incidentNumberText + '</p>\n' +
        '</div>\n' +
        divColSix +
        '<p>' + data.incidentNumber + '</p>\n' +
        '</div>\n' +
        '</div>';
    }

    if (data.workOrderNumber !== '' && data.workOrderNumber !== null) {
      structure = structure + divColTwelve +
        divColSix +
        pStrong + workOrderNumberText + '</p>\n' +
        '</div>\n' +
        divColSix +
        '<p class="ph-order-mail-id">' + data.workOrderNumber + '</p>\n' +
        '</div>\n' +
        '</div>';
    }

    return structure;
  },
  createSmaxLink: function(data, returnOrder) {
    var smaxText = '';

    if (String(data.isSparePartOrder) === 'true' && data.workOrderNumber !== '' && data.smaxSystem !== '' && data.workOrderId !== '') {
      var smaxLink = $('.ph-orderhistory__smaxLink').attr('data-' + data.smaxSystem);

      if (data.smaxSystem === 'Distributors') {
        smaxLink = smaxLink + data.workOrderId;
      }

      smaxText = '<a href="' + smaxLink + '">' + $('.ph-orderhistory__smaxLink').text() + '</a>';
    }

    smaxText = smaxText + '</form>\n' + returnOrder +
    '</div>\n' +
    '</div>';

    return smaxText;
  },
  setProductImage: function(data) {
    var prodlistStruc = '',
        lumifyAnchorTag = '<a>',
        imageTag = '<img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage ph-orderhistory__lazyimage" src="',
        imageClass = '" class="thumb"/>\n',
        prodInfo = '<div class="prod_info ph-float-left ph-pr-0 ph-orderhistory_prodinfo">\n' +
        '<div class=" ph-float-left ph-col-md-12 ph-col-sm-12 ph-p-0">\n' +
        '<a class="ph-orderhistory_prodname ph-float-left ph-col-12 ph-p-0"  ',
        prodInfoFullWidth = '<div class="prod_info ph-float-left ph-pr-0 ph-orderhistory_prodinfo ph-full__width">\n' +
        '<div class=" ph-float-left ph-col-md-12 ph-col-sm-12 ph-p-0">\n' +
        '<a class="ph-orderhistory_prodname ph-float-left ph-col-12 ph-p-0"  ';

    if (String(data.isSparePartOrder) === 'true') {
      if (data.product.imageURL === null) {
        prodlistStruc = prodlistStruc + prodInfoFullWidth;
      } else {
        prodlistStruc = prodlistStruc + '<div class="ph-float-left ph-orderhistory_prodimg ph-pr-1">' +
        '<a href=' + data.product.url + '> <div class="ph-p-0">\n' +
        imageTag + data.product.imageURL + imageClass +
        '</div>\n</a>\n</div>\n' + prodInfo;
      }
    } else {
      prodlistStruc = prodlistStruc + '<div class="ph-float-left ph-orderhistory_prodimg ph-pr-1">';

      if (data.product.isLumifyWarranty !== '' && data.product.isLumifyWarranty !== null) {
        if (data.product.approval === 'approved' || data.product.approval === 'regulatoryonhold') {
          lumifyAnchorTag = '<a href=' + data.product.url + '>';
        }
      }

      prodlistStruc = prodlistStruc + lumifyAnchorTag;

      if (data.product.imageURL === null) {
        var noImage = ACC.config.commonResourcePath + '/philipsUI/src/images/no-image-130x130.gif';

        prodlistStruc = prodlistStruc + '<div class="ph-p-0">\n' +
        imageTag + noImage + imageClass +
        '</div>\n';
      } else {
        prodlistStruc = prodlistStruc + ' <div class="ph-p-0">\n' +
        imageTag + data.product.imageURL + imageClass +
        '</div>\n';
      }

      prodlistStruc = prodlistStruc + '</a>\n' +
      '</div>\n' + prodInfo;
    }

    return prodlistStruc;
  }
};
